<div>
    <img src="assets/zenzologo.PNG" alt="">    
</div>